import React, { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import CoreFunctions from '../components/CoreFunctions';
import Membership from '../components/Membership';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import { Toaster } from '../components/ui/sonner';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <About />
      <CoreFunctions />
      <Membership />
      <CTASection />
      <Footer />
      <Toaster />
    </div>
  );
};

export default LandingPage;
